import { QueryDispatcher } from "@/modules/shared/domain/QueryDispatcher";

export class BankAccountQuery {
  constructor(
    private readonly dispatcher: QueryDispatcher,
    private readonly frontend,
  ) { }

  async run(bank_account_id:string): Promise<any> {
    let args = { 
        bank_account_id: bank_account_id,
    }
    let res = undefined;    
    res = await this.dispatcher.dispatch('get.bank_account', args)    
    if (res.status === '200') {
      this.frontend.currentBankAccount = res.data      
    } else {
      return res.data
    }    
  }
}